module.exports = __webpack_public_path__ + "img/360.3ba44055.svg";